import { Type } from "@angular/core";
import { TypeId } from "./user.model";

export class Organization {
    id: number;
    name: string;
    contactPersonName: string;
    contactPersonPhone: string;
    address: string;
    city: string;
    province: string; // Province / State / Region
    postalCode: string;
    countryCode: string;
    country: string;
    webSite: string;
    vat: string;
    status: number;
    logo: string;
    notes: string;
    //deliveryAddress
    typeId: TypeId;
    orderType: number; // 1 = bulk, 2 = dropshipping
    creationDate: Date;
    vendorId: number;
}

export enum StatusId {
    Enabled = 1,
    Disabled = 2,
    Deleted = 3,
}